/**
 * CUBE - RELOAD CARTRIDGE LIBRARY
 */
module.exports = function(idCartridge) {
  return new CubeCartridge(idCartridge);
};

var ajax = require('./lib-ajax');
var noop = function() {};

/**
 * CubeCartridge
 *
 * @param {any} id
 * @returns
 */
function CubeCartridge(id) {
  this._id = id;
  this._loader = false;
  this._cbBefore = noop;
  this._cbAfter = noop;

  return this;
}

/**
 *  Executed before calling reload cartridge
 */
CubeCartridge.prototype.before = function(cb) {
  this._cbBefore = cb; return this;
}

/**
 *  Executed after calling reload cartridge
 */
CubeCartridge.prototype.after = function(cb) {
  this._cbAfter = cb; return this;
}

/**
 *  If 'true', the cartridge will display a loader
 */
CubeCartridge.prototype.loader = function(bool) {
  this._loader = bool; return this;
}

/**
 *  Effective method that reload the cartridge
 */
CubeCartridge.prototype.reload = function(extParams) {
  var self = this;
  var cartridge = document.getElementById(this._id);
  if (!cartridge) return;

  var url = (cartridge.dataset.tUrlActor != null) ? 'reloadCartridgeFromActor' : 'reloadCartridgeContentCollection';
  var params = {};
  params.cartridgePlayViewClassName = cartridge.dataset.tPath;
  params.cartridgeExemTemplateUrl = cartridge.dataset.tUrl;

  if(extParams && typeof extParams === 'object') params.cartridgeParams = ajax.encode(extParams);
  if(extParams && typeof extParams === 'string') params.cartridgeParams = extParams;

  if (self._loader) cartridge.style.visibility = 'hidden'
  if (self._cbBefore) self._cbBefore(cartridge)

  ajax.post(url, params, true)
    .onSuccess(function(response) {
      window.$(window).trigger('cartridge.reload');
      if(response && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].message) {
        cube.alert.error(window.Messages(response.responseTO.errors[0].message));
      } else {
        cartridge.outerHTML = response;
      }

      if (self._loader) cartridge.style.visibility = ''
      if (self._cbAfter) self._cbAfter(response)
    })
    .onError(function(err) {
      if (self._loader) cartridge.style.visibility = ''
      if (self._cbAfter) self._cbAfter(cartridge)
      console.warn('Unable to reload cartridge "' + self._id + '"')
      if (err.error && err.error.message) console.warn('Message : ', err.error.message)
      console.error(err)
    })
    .call()
}

// When a cartridge is reloaded (with the 'old' reloadCartridgeContent), a 'cartridge.reload' event is triggered
// We lauch the cube.lazyload (on the body), to init the lazy-load mecanism on newly refreshed images
$(window).on('cartridge.reload', function() {
  cube.lazyload.updateObserver();
})



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-cartridge.js